import React, { useEffect, useState } from "react";
import Layout from "../layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import axios from "axios";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Breadcrumb,
  Alert,
  Spinner,
} from "react-bootstrap";

const PabrikAddProduksi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  const [idOrders, setIdOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [formData, setFormData] = useState({
    Idorderdipakai: "",
    tanggalProduksi: "",
    Jenisolahan: "",
    jumlahproduksiharian: "",
    kualitasOutput: "",
    permasalahanOperasional: "",
    kebutuhanPerbaikan: "",
    limbahcair: "",
    catatanlimbah: "",
    limbahpadat: "",
    catatanlimbahpadat: "",
  });

  useEffect(() => {
    dispatch(getMe());
    fetchIdOrders();
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin" && user.role !== "pabrik") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);

  const fetchIdOrders = async () => {
    setLoading(true);
    setErrorMessage("");
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Token tidak ditemukan");

      const response = await axios.get(
        "https://c-greenproject.org:8000/getidorder",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (Array.isArray(response.data)) {
        setIdOrders(response.data);
      } else {
        throw new Error("Format data tidak sesuai");
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.msg ||
          "Gagal mengambil ID Order. Periksa koneksi atau otorisasi."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const savePabrik = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const token = localStorage.getItem("token");

    try {
      await axios.post("https://c-greenproject.org:8000/produksi", formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSuccessMessage("Data produksi berhasil disimpan.");
      setTimeout(() => {
        navigate("/produksi");
      }, 1500);
    } catch (error) {
      const responseMsg = error.response?.data?.msg;
      if (responseMsg) {
        setErrorMessage(responseMsg);
      } else {
        setErrorMessage("Gagal menyimpan data produksi.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Container>
        <Breadcrumb>
          <Breadcrumb.Item href="/produksi">Data Produksi</Breadcrumb.Item>
          <Breadcrumb.Item active>Tambah Data Produksi Harian</Breadcrumb.Item>
        </Breadcrumb>

        <h2 className="mb-4">
          <strong>Tambah Data Produksi Harian</strong>
        </h2>

        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        {successMessage && (
          <Alert className="text-center custom-success-alert">
            {successMessage}
          </Alert>
        )}
        {loading && <Spinner animation="border" />}

        <Card className="p-4 mb-3 shadow">
          <Form onSubmit={savePabrik}>
            <Form.Group className="mb-3">
              <Form.Label>ID Order</Form.Label>
              <Form.Select
                name="Idorderdipakai"
                value={formData.Idorderdipakai}
                onChange={handleChange}
                required
              >
                <option value="">Pilih ID Order</option>
                {idOrders.map((order, index) => (
                  <option key={index} value={order.id}>
                    {order}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal Produksi</Form.Label>
                  <Form.Control
                    type="date"
                    name="tanggalProduksi"
                    value={formData.tanggalProduksi}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Jenis Olahan</Form.Label>
                  <Form.Control
                    type="text"
                    name="Jenisolahan"
                    value={formData.Jenisolahan}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Jumlah Produksi Harian (kg)</Form.Label>
                  <Form.Control
                    type="number"
                    name="jumlahproduksiharian"
                    value={formData.jumlahproduksiharian}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Limbah Cair (liter)</Form.Label>
                  <Form.Control
                    type="number"
                    name="limbahcair"
                    value={formData.limbahcair}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Limbah Padat (kg)</Form.Label>
                  <Form.Control
                    type="number"
                    name="limbahpadat"
                    value={formData.limbahpadat}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Permasalahan Operasional</Form.Label>
                  <Form.Control
                    type="text"
                    name="permasalahanOperasional"
                    value={formData.permasalahanOperasional}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Kebutuhan Perbaikan</Form.Label>
                  <Form.Control
                    type="text"
                    name="kebutuhanPerbaikan"
                    value={formData.kebutuhanPerbaikan}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Kualitas Output</Form.Label>
                  <Form.Control
                    type="text"
                    name="kualitasOutput"
                    value={formData.kualitasOutput}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Catatan Limbah Cair</Form.Label>
                  <Form.Control
                    type="text"
                    name="catatanlimbah"
                    value={formData.catatanlimbah}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Catatan Limbah Padat</Form.Label>
                  <Form.Control
                    type="text"
                    name="catatanlimbahpadat"
                    value={formData.catatanlimbahpadat}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button variant="success" type="submit">
              Simpan
            </Button>
          </Form>
        </Card>
      </Container>
    </Layout>
  );
};

export default PabrikAddProduksi;
